<menu>
    <div class="container">
        <nav>
            <ul>
                <li>
                    <a routerLink="/mypolls" class="logo-header" >wb.form</a>
                </li>
                <ng-container *ngIf="auth.isLoggedIn; then profile else signIn"></ng-container>
                <ng-template #profile>
                    <li class="profile">
                        <a routerLink="/profile" routerLinkActive="active" >
                            <i class="fas fa-user-alt"></i>
                            Профиль
                        </a>
                    </li>
                </ng-template>
                <ng-template #signIn>
                    <li class="sign-in"><button mat-raised-button  (click)="openLogin()">Войти</button></li>
                </ng-template>
            </ul>
        </nav>
    </div>
</menu>